import { useModule } from "core/controller/useModule"
import type { ThemeModule } from "core/modules/themes/Theme"

export const useTheme = () => useModule<ThemeModule>("Theme")
